import React, { useState } from "react";
import PropTypes from "prop-types";
import BiAxialLineChart from "../biAxialLineChart/biAxialLineChart";
import Modal from "react-modal";
import Table from "../coreUiTable/Table";
import { stripHTMLTagsFromText } from "../../utils/formatters";
import ClientsInfoDetails from "./views/ClientInfoDetails";
import { DataPoints } from "./views/DataPoints";

const ClientInfo = (props) => {
  const {
    clientContracts,
    contactLogs = {},
    contractStatuses,
    contractFreezes,
    salesData,
    pastDuesData,
    membershipTypesData,
    prospectTypesData,
    visitsData,
    currentInfo,
    quickFacts,
    clientInfo,
    sourceType,
    clientLogsLoading,
    chartData,
    isAdmin,
    haveError,
    error,
    apiError
  } = props;
  const [state, setState] = useState({
    modalContent: null,
    modalOpen: false,
    modalType: ""
  });

  const getParent = () => {
    return document.querySelector("body");
  };
  const closeModal = () => {
    setState((prevState) => ({
      ...prevState,
      modalOpen: false,
      staffValue: "select"
    }));
  };
  const renderModal = () => {
    return (
      <Modal
        closeTimeoutMS={500}
        ariaHideApp={false}
        parentSelector={getParent}
        className={state.modalType === "createLog" ? "addContactLogModal" : "handsonTable__modal"}
        isOpen={state.modalOpen}
        onRequestClose={closeModal}
        overlayClassName="handsonTable__modal--overlay"
        style={
          state.modalType === "createLog"
            ? {
                overlay: {
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                  zIndex: 10000
                },
                content: {
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: 800,
                  height: 550,
                  bottom: 40,
                  backgroundColor: "white",
                  borderRadius: "10px",
                  border: "solid 1px #444",
                  padding: "25px",
                  outline: "none",
                  zIndex: 100000,
                  overflow: "scroll",
                  margin: "-275px 0 0 -400px"
                }
              }
            : {}
        }
        contentLabel={state.modalType === "createLog" ? "Contact Log Modal" : "Messages Modal"}
      >
        {state.modalType === "view" ? (
          <div
            className="handsonTable__modal--content"
            dangerouslySetInnerHTML={{ __html: state.modalContent }}
          />
        ) : (
          ""
        )}
      </Modal>
    );
  };
  const toggleModal = (type, content = "") => {
    setState((prevState) => ({
      ...prevState,
      modalOpen: true,
      modalContent: content,
      modalType: type // "createLog" or "view"
    }));
  };

  const errorMessage = () => {
    return (
      <p className="error">
        Oops, we ran into the following error:
        <br />
        <span>{error}</span>
        <br />
        Please try again.
      </p>
    );
  };

  const clientInfoSections = () => {
    const salesTableTitle = sourceType === "mindbody" ? "Accrual Sales" : "Sales";
    return (
      <>
        <ClientsInfoDetails
          currentInfo={currentInfo}
          clientInfo={clientInfo}
          quickFacts={quickFacts}
        />
        <div className="client-info-bottom-wrapper">
          <div className="client-info-bottom chart">
            <div className="cell">
              <p className="title">Sales and Visits Data</p>
              <BiAxialLineChart chartData={chartData} />
            </div>
          </div>
          {clientContracts.tableInfo.data?.length !== 0 && (
            <Table
              table={clientContracts.tableInfo}
              title={"Contracts/Agreements"}
              tableWrapperId={"client-info"}
            />
          )}
          {contractFreezes.tableInfo.data?.length !== 0 && isAdmin && (
            <Table
              table={contractFreezes.tableInfo}
              title={"Freezes"}
              tableWrapperId={"client-info"}
            />
          )}
          {contractStatuses.tableInfo.data?.length !== 0 && isAdmin && (
            <Table
              table={contractStatuses.tableInfo}
              title={"Membership Statuses"}
              tableWrapperId={"client-info"}
            />
          )}
          {membershipTypesData.tableInfo.data?.length > 0 && (
            <Table
              table={membershipTypesData.tableInfo}
              title={"Membership Types"}
              tableWrapperId={"client-info"}
            />
          )}
          {prospectTypesData.tableInfo.data?.length > 0 && (
            <Table
              table={prospectTypesData.tableInfo}
              title={"Prospect Types"}
              tableWrapperId={"client-info"}
            />
          )}
          {salesData.tableInfo.data?.length > 0 && (
            <Table
              table={salesData.tableInfo}
              title={salesTableTitle}
              tableWrapperId={"client-info"}
            />
          )}
          {pastDuesData.tableInfo.data?.length > 0 && (
            <Table
                table={pastDuesData.tableInfo}
                title={"Past Dues"}
                tableWrapperId={"client-info"}
            />
          )}
          {visitsData.tableInfo.data?.length !== 0 && (
            <Table table={visitsData.tableInfo} title={"Visits"} tableWrapperId={"client-info"} />
          )}

          {contactLogs.tableInfo.data.length > 0 && (
            <>
              <DataPoints dataPoints={contactLogs.dataPoints} />
              <Table
                table={contactLogs.tableInfo}
                title={"Contact Logs"}
                tableWrapperId={"client-contact-logs"}
                logs={{
                  add: toggleModal
                }}
                overrideColumnCallback={(header) => ({
                  _style: header === "Description" ? { width: "30%" } : {}
                })}
                scopedSlots={{
                  Description: (item) => {
                    let rowText = stripHTMLTagsFromText(item.Description).substring(0, 100);
                    return (
                      <td>
                        <div className="text-ellipsis">
                          {rowText}{" "}
                          <a
                            className="contact-logs-view-message"
                            onClick={() => toggleModal("view", item.Description)}
                          >
                            View
                          </a>
                        </div>
                      </td>
                    );
                  }
                }}
              />
            </>
          )}
        </div>
      </>
    );
  };
  if (apiError) {
    throw new Error("api url has error");
  }
  return (
    <div className="client-info-wrapper">
      {!clientLogsLoading && renderModal()}
      {haveError ? errorMessage() : clientInfoSections()}
    </div>
  );
};

ClientInfo.propTypes = {
  clientInfo: PropTypes.object,
  quickFacts: PropTypes.object,
  currentInfo: PropTypes.object,
  visitsData: PropTypes.object,
  salesData: PropTypes.object,
  pastDuesData: PropTypes.object,
  membershipTypesData: PropTypes.object,
  prospectTypesData: PropTypes.object,
  contactLogs: PropTypes.object,
  clientContracts: PropTypes.object,
  contractStatuses: PropTypes.object,
  contractFreezes: PropTypes.object,
  sourceType: PropTypes.string,
  chartData: PropTypes.object,
  haveError: PropTypes.bool,
  error: PropTypes.string,
  isAdmin: PropTypes.bool,
  contactsLoading: PropTypes.bool,
  clientLogsLoading: PropTypes.bool,
  apiError: PropTypes.bool
};

export default ClientInfo;
